import { CSSObject } from "styled-components";

interface LoadingIndicatorStyles {
  container: CSSObject;
}

const useLoadingIndicatorStyles = (): LoadingIndicatorStyles => {
  return {
    container: {
          display: "grid",
          placeItems: "center",
          height: "100%",    
          width: "100%",
    },
  };
};

export default useLoadingIndicatorStyles;
